import type { IFieldOptions } from '@axo/form/feature/form-input/types';
import { PHONE_REGEX } from '../../config/globals';

export const phoneFieldOptions = {
  maxLength: 12,
  registerOptions: {
    required: 'MobilePhoneNumber.error.required',
    maxLength: {
      value: 13,
      message: 'MobilePhoneNumber.error.pattern',
    },
    setValueAs: (value) => value.trim(),
    validate: {
      pattern: (value) => {
        const formattedValue = value.replaceAll(' ', '');
        if (!PHONE_REGEX.test(formattedValue)) {
          return 'MobilePhoneNumber.error.pattern';
        }
      },
    },
  },
} satisfies IFieldOptions;
